import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button, Spin, Result } from 'antd';
import { selectAuth } from '../redux/store/userData/user/selectors';
import { login } from '../redux/store/userData/user/thunk';
import { history, navigateTo } from '../utils';
import SharePointSetupWizard from '../components/SharePointSetup/SharePointSetupWizard';

const SharePointSetup = () => {
  const dispatch = useDispatch();
  const user = useSelector(selectAuth);
  const fetchTriggered = useRef(false);

  // Not logged in — redirect to login
  if (!user?.token) {
    navigateTo(history, '/login.html');
    window.location.reload();
    return null;
  }

  // Fetch fresh admin data on mount
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if (!fetchTriggered.current) {
      fetchTriggered.current = true;
      dispatch(login(user.token) as any);
    }
  }, []);

  // Show spinner until the login fetch completes (loading goes true then false)
  if (!fetchTriggered.current || user.loading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          background: '#f5f5f5',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  // No merchantManager permission — show 403 inline
  if (!user?.permissions?.merchantManager) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          background: '#f5f5f5',
        }}
      >
        <Result
          icon={<></>}
          title="403"
          subTitle="You do not have permission to access this page."
        />
      </div>
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        minHeight: '100vh',
        padding: '64px 16px',
        background: '#f5f5f5',
      }}
    >
      <SharePointSetupWizard />
    </div>
  );
};

export default SharePointSetup;
